<template>
	<c-dialog ref="dialog" width="1300" height="600" enable-flex @resolve="submitHandle">
		<c-tab-list v-show="mode != 3" ref="modeTab" :tabs="modeTabs" type="border-tab" :immediate="false" @change="tabChange">
			<template #default="{data}">
				<span>{{data.name}}</span>
			</template>
		</c-tab-list>

		<!-- 同SKU调整到相同价 -->
		<div v-show="mode == 1" class="m-price-edit flex-column flex-grow">
			<div class="m-toolbar flex">
				<c-select v-model="categoryId" async @search="searchCategory" @change="categoryChange" placeholder="产品分类" style="width: 130px;"></c-select>
				<c-select v-model="brandId" async @search="searchBrand" placeholder="品牌型号" style="width: 130px;"></c-select>
				<c-select v-model="levelType" :options="levelTypeOptions" placeholder="等级" style="width: 110px;"></c-select>
				<c-select v-model="channelId" async @search="searchChannel" placeholder="推送渠道" style="width: 130px;"></c-select>
				<c-button color="main" @click="querySkuList">查询</c-button>
				<c-button :hollow="true" @click="resetFilter">重置</c-button>
			</div>
			<div class="m-table-area flex-column flex-grow">
				<div class="m-fill-bar flex-center-cross">
					<div class="m-fill-right flex-center">
						<label>批量填充：</label>
						<c-input type="number" decimal="2" :range="[0, 99999999]" v-model="fillPrice" placeholder="定价" style="width: 120px;"></c-input>
						<c-button :hollow="true" @click="fillAllPrice">填充</c-button>
					</div>
				</div>
				<c-table ref="skuList" :data="productList" height="grow" :paging="false" empty-text="暂无商品数据，请先查询">
					<c-table-column label="背贴码" name="produce_unique_code" width="140"></c-table-column>
					<c-table-column label="产品信息" width="330">
						<template #default="{data}">
							<span v-if="data.level_name" class="m-tag" :class="levelClass(data.level_name)">{{data.level_name}}</span>
							<span>{{data.product_info || getProductText(data)}}</span>
						</template>
					</c-table-column>
					<c-table-column label="调整后定价" width="240">
						<template #default="{data}">
							<div class="m-new-price">
								<p class="flex">
									<label>修改定价：</label>
									<c-input class="m-price-input" :class="{'m-price-below': isBelowPrice(data, data.new_sale_price)}" type="number" decimal="2" :range="[0, 99999999]" v-model="data.new_sale_price" placeholder="请输入" style="width: 110px;"></c-input>
									<span class="m-unit">元</span>
								</p>
								<p v-if="isBelowPrice(data, data.new_sale_price)" class="m-below-tip">{{belowTipText}}</p>
								<p class="m-settle flex">
									<span>预计结算价：{{formatAmount(getEstimateSettle(data))}}</span>
									<span class="m-help-wrap">
										<c-tooltip tip="预计结算价按渠道结算规则测算，实际以结算账单为准">
											<span class="m-help">?</span>
										</c-tooltip>
									</span>
								</p>
							</div>
						</template>
					</c-table-column>
					<c-table-column label="当前渠道定价" width="170">
						<template #default="{data}">
							<div v-if="getCurrentChannel(data)" class="m-channel-price">
								<p>{{getCurrentChannel(data).channel_name}}：{{formatAmount(getCurrentChannel(data).sale_price)}}</p>
								<p class="m-settle flex">
									<span>预计结算价：{{formatAmount(getChannelSettle(data, getCurrentChannel(data)))}}</span>
									<span class="m-help-wrap">
										<c-tooltip tip="预计结算价按渠道结算规则测算，实际以结算账单为准">
											<span class="m-help">?</span>
										</c-tooltip>
									</span>
								</p>
							</div>
							<div v-else-if="(data.channel_list || []).length" class="m-multi-line">
								<p v-for="(channel, i) in data.channel_list" :key="i">
									{{channel.channel_name}}：{{formatAmount(channel.sale_price)}}
								</p>
							</div>
							<span v-else>-</span>
						</template>
					</c-table-column>
					<c-table-column label="定价参考" width="170">
						<template #default="{data}">
							<div v-if="(data.reference_price_list || []).length" class="m-multi-line">
								<p v-for="(ref, i) in data.reference_price_list" :key="i">
									{{ref.channel_name}}参考价：{{formatPrice(ref.sale_price)}}
								</p>
							</div>
							<span v-else>-</span>
						</template>
					</c-table-column>
					<c-table-column label="上次调价时间" name="last_price_date" width="130"></c-table-column>
				</c-table>
			</div>
		</div>

		<!-- 所有背贴码统一调整金额 -->
		<div v-show="mode == 2" class="m-price-edit flex-column flex-grow">
			<div class="m-amount-form flex">
				<c-select v-model="amountChannelId" async @search="searchChannel" placeholder="销售渠道" style="width: 130px;"></c-select>
				<label>调价方式：</label>
				<c-radio-group v-model="adjustType" :options="adjustTypeOptions"></c-radio-group>
                <label>&nbsp;调价金额：</label>
				<c-input type="number" decimal="2" :range="[0, 99999999]" v-model="adjustAmount" :placeholder="adjustType == 1 ? '请输入涨价值' : '请输入降价值'" append-text="元" style="width: 180px;"></c-input>
				<c-button color="main" @click="applyAmount">确定</c-button>
				<c-button :hollow="true" @click="resetAmount">重置</c-button>
			</div>
			<p class="m-amount-tips">温馨提示：点击『确定』后，所有商品会在当前定价基础上统一调价；点击『重置』，将会清空当前所有商品修改后的价格。</p>

			<div class="m-table-area flex-column flex-grow">
				<c-table ref="amountList" :data="productList" height="grow" :paging="false" empty-text="暂无商品数据">
					<c-table-column label="背贴码" name="produce_unique_code" width="140"></c-table-column>
					<c-table-column label="产品信息" width="330">
						<template #default="{data}">
							<span v-if="data.level_name" class="m-tag" :class="levelClass(data.level_name)">{{data.level_name}}</span>
							<span>{{data.product_info || getProductText(data)}}</span>
						</template>
					</c-table-column>
					<c-table-column label="调整后定价" width="280">
						<template #default="{data}">
							<div v-if="getAmountChannels(data).length" class="m-multi-line">
								<p v-for="(channel, i) in getAmountChannels(data)" :key="i">
									<span class="red">{{channel.channel_name}}：{{formatAmount(getAmountPrice(data, channel))}}元</span>
									<span v-if="isBelowPrice(data, getAdjustPrice(channel))" class="m-below-tag">低于控价</span>
									<span class="m-settle m-settle-inline">预计结算价：{{formatAmount(getAmountSettle(data, channel))}}</span>
								</p>
							</div>
							<span v-else>-</span>
						</template>
					</c-table-column>
					<c-table-column label="当前定价" width="160">
						<template #default="{data}">
							<div v-if="(data.channel_list || []).length" class="m-multi-line">
								<p v-for="(channel, i) in data.channel_list" :key="i">
									{{channel.channel_name}}：{{formatAmount(channel.sale_price)}}元
								</p>
							</div>
							<span v-else>-</span>
						</template>
					</c-table-column>
					<c-table-column label="定价参考" width="170">
						<template #default="{data}">
							<div v-if="(data.reference_price_list || []).length" class="m-multi-line">
								<p v-for="(ref, i) in data.reference_price_list" :key="i">
									{{ref.channel_name}}参考价：{{formatPrice(ref.sale_price)}}元
								</p>
							</div>
							<span v-else>-</span>
						</template>
					</c-table-column>
					<c-table-column label="上次调价时间" name="last_price_date" width="120"></c-table-column>
				</c-table>
			</div>
		</div>

		<!-- 单商品渠道改价：与同SKU模式同款表格结构，仅本商品一行，渠道固定为点击的渠道（必须用v-if：初始singleProduct/singleChannel为null，v-show会提前渲染表达式导致报错弹框无法挂载） -->
		<div v-if="mode == 3" class="m-price-edit flex-column flex-grow">
			<div class="m-table-area flex-column flex-grow">
				<c-table ref="singleList" :data="singleList" height="grow" :paging="false" empty-text="暂无商品数据">
					<c-table-column label="背贴码" name="produce_unique_code" width="140"></c-table-column>
					<c-table-column label="产品信息" width="330">
						<template #default="{data}">
							<span v-if="data.level_name" class="m-tag" :class="levelClass(data.level_name)">{{data.level_name}}</span>
							<span>{{data.product_info || getProductText(data)}}</span>
						</template>
					</c-table-column>
					<c-table-column label="调整后定价" width="240">
						<template #default="{data}">
							<div class="m-new-price">
								<p class="flex">
									<span>修改定价：</span>
									<c-input class="m-price-input" :class="{'m-price-below': isBelowPrice(data, data.new_sale_price)}" type="number" decimal="2" :range="[0, 99999999]" v-model="data.new_sale_price" placeholder="请输入" style="width: 110px;"></c-input>
									<span class="m-unit">元</span>
								</p>
								<p v-if="isBelowPrice(data, data.new_sale_price)" class="m-below-tip">{{belowTipText}}</p>
								<p class="m-settle flex">
									<span>预计结算价：{{formatAmount(getEstimateSettle(data))}}</span>
									<span class="m-help-wrap">
										<c-tooltip tip="预计结算价按渠道结算规则测算，实际以结算账单为准">
											<span class="m-help">?</span>
										</c-tooltip>
									</span>
								</p>
							</div>
						</template>
					</c-table-column>
					<c-table-column label="当前渠道定价" width="170">
						<template #default="{data}">
							<div class="m-channel-price">
								<p>{{singleChannel.channel_name}}：{{formatAmount(singleChannel.sale_price)}}</p>
								<p class="m-settle flex">
									<span>预计结算价：{{formatAmount(getChannelSettle(data, singleChannel))}}</span>
									<span class="m-help-wrap">
										<c-tooltip tip="预计结算价按渠道结算规则测算，实际以结算账单为准">
											<span class="m-help">?</span>
										</c-tooltip>
									</span>
								</p>
							</div>
						</template>
					</c-table-column>
					<c-table-column label="定价参考" width="170">
						<template #default="{data}">
							<div v-if="(data.reference_price_list || []).length" class="m-multi-line">
								<p v-for="(ref, i) in data.reference_price_list" :key="i">
									{{ref.channel_name}}参考价：{{formatPrice(ref.sale_price)}}
								</p>
							</div>
							<span v-else>-</span>
						</template>
					</c-table-column>
					<c-table-column label="上次调价时间" name="last_price_date" width="120"></c-table-column>
				</c-table>
			</div>
		</div>
	</c-dialog>
</template>

<script>
	import { fetchSettleConfig, calcSettlePrice } from '@/components/public/settle.js';

	export default {
		name: 'salePriceEdit',

		data() {
			return {
				modeTabs: [{
					name: '同sku调整到相同价',
					value: 1
				}, {
					name: '所有背贴码统一调整金额',
					value: 2
				}],
				mode: 1,
				viewId: '',
				categoryId: '',
				brandId: '',
				levelType: '',
				channelId: '',
				levelTypeOptions: [],
				productList: [],
				listFiltered: false,
				fillPrice: '',
				adjustType: 1,
				adjustAmount: '',
				amountChannelId: '',
				adjustTypeOptions: [{
					name: '涨价',
					value: 1
				}, {
					name: '降价',
					value: 2
				}],
				singleProduct: null,
				singleChannel: null,
				singleList: [],
				/**控价处置方式（1-严格拦截 2-仅提醒），与后端 sale_price_control_mode 同一取值*/
				controlMode: 2,
				/**渠道结算公式集合（{channel_id: {android:[], apple:[]}}），预计结算价测算依据*/
				settleConfigMap: {}
			}
		},

		computed: {
			/*********控价方式是否为严格拦截（拦截模式下破价前端直接挡回）**********/
			blockMode() {
				return this.controlMode == 1;
			},

			/*********输入框下方破价提示文案**********/
			belowTipText() {
				return '低于控价';
			}
		},

		mounted() {
			this.loadLevelOptions();
		},

		methods: {
			/*********打开弹框（product+channel 进入单品渠道改价模式）**********/
			open(data) {
				data = data || {};
				this.loadPriceControlMode();
				/**结算公式随弹框打开拉一次，总后台改配置后重开弹框即生效*/
				this.loadSettleConfig();
				this.singleProduct = data.product || null;
				this.singleChannel = data.channel || null;
				if (this.singleProduct && this.singleChannel) {
					// 表格行：仅本商品，预置空的新定价输入位
					var row = Object.assign({}, this.singleProduct);
					row.new_sale_price = '';
					this.singleList = [row];
					this.mode = 3;
					this.$refs.dialog.open({
						title: '改价',
						buttonName: '确认提交'
					});
					return;
				}
				this.viewId = data.view_id || '';
				this.mode = 1;
				this.categoryId = '';
				this.brandId = '';
				this.levelType = '';
				this.channelId = '';
				this.productList = [];
				this.listFiltered = false;
				this.fillPrice = '';
				this.adjustType = 1;
				this.adjustAmount = '';
				this.amountChannelId = '';
				this.$refs.dialog.open({
					title: '批量改价',
					buttonName: '确认提交'
				});
				this.$nextTick(() => {
					this.$refs.modeTab.changeIndex(0);
				});
				this.loadProductList();
			},

			/*********切换改价模式**********/
			tabChange(tab) {
				this.mode = tab.value;
				if (this.mode == 2) {
					this.ensureAmountList();
				}
			},

			/*********统一调整模式下确保列表为全量数据**********/
			ensureAmountList() {
				if (this.listFiltered) {
					this.loadProductList();
				}
			},

			/*********加载等级选项**********/
			loadLevelOptions() {
				this.request({
					url: '/dic/info/options',
					data: {
						dic_type_code: 'LEVEL_TYPE'
					},
					success: data => {
						this.levelTypeOptions = data;
					}
				});
			},

			/*********搜索产品分类**********/
			searchCategory(keyword, resolve) {
				this.request({
					url: '/spu/category/options',
					data: {keyword},
					success: data => {
						resolve(data);
					}
				});
			},

			/*********搜索品牌型号**********/
			searchBrand(keyword, resolve) {
				this.request({
					url: '/spu/brand/options',
					data: {
						category_id: this.categoryId,
						keyword
					},
					success: data => {
						resolve(data);
					}
				});
			},

			/*********分类变更后清空品牌**********/
			categoryChange() {
				this.brandId = '';
			},

			/*********搜索推送渠道（接口返回channel_id/channel_name，需映射为name/value）**********/
			searchChannel(keyword, resolve) {
				this.request({
					url: '/sale/product/channel/options',
					data: {
						keyword: keyword
					},
					success: data => {
						resolve((data || []).map(item => {
							return {
								name: item.channel_name,
								value: item.channel_id
							};
						}));
					}
				});
			},

			/*********查询同SKU商品列表**********/
			querySkuList() {
				if (!this.channelId) {
					this.$message({message: '请先选择推送渠道', type: 'warn'});
					return;
				}
				this.loadProductList({
					category_id: this.categoryId,
					brand_id: this.brandId,
					level_type: this.levelType,
					channel_id: this.channelId
				});
			},

			/*********重置筛选条件**********/
			resetFilter() {
				this.categoryId = '';
				this.brandId = '';
				this.levelType = '';
				this.channelId = '';
				this.loadProductList();
			},

			/*********加载商品列表（params为空时加载全量）**********/
			loadProductList(params) {
				params = params || {};
				this.request({
					url: '/sale/product/list',
					data: Object.assign({
						view_id: this.viewId,
						pageIndex: 1,
						pageSize: 100,
                        state: 32
					}, params),
					loading: true,
					success: data => {
						this.listFiltered = Object.keys(params).some(key => {
							return params[key] !== '' && params[key] !== null && params[key] !== undefined;
						});
						this.productList = (data || []).map(item => {
							item.new_sale_price = '';
							item._amountApplied = false;
							return item;
						});
					}
				});
			},

			/*********批量填充修改定价（表格data深拷贝，需直接操作行数据）**********/
			fillAllPrice() {
				if (this.fillPrice === '' || parseFloat(this.fillPrice) <= 0) {
					this.$message({message: '请输入要填充的定价', type: 'warn'});
					return;
				}
				var rows = this.$refs.skuList.rows || [];
				if (!rows.length) {
					this.$message({message: '请先查询商品列表', type: 'warn'});
					return;
				}
				rows.forEach(row => {
					this.$set(row.data, 'new_sale_price', this.fillPrice);
				});
			},

			/*********获取当前改价渠道的定价信息**********/
			getCurrentChannel(data) {
				if (!this.channelId) return null;
				return (data.channel_list || []).find(item => item.channel_id == this.channelId) || null;
			},

			/*********加载渠道结算公式（仅用于测算展示，不参与提交校验）**********/
			loadSettleConfig() {
				this.settleConfigMap = {};
				fetchSettleConfig(this, map => {
					this.settleConfigMap = map;
				});
			},

			/*********调整后预计结算价：同SKU模式按筛选渠道测算，单品模式渠道固定为singleChannel**********/
			getEstimateSettle(data) {
				var channelId = this.mode == 3 && this.singleChannel ? this.singleChannel.channel_id : this.channelId;
				return calcSettlePrice(this.settleConfigMap, channelId, data.brand_name, data.new_sale_price);
			},

			/*********渠道当前定价的预计结算价（需带行数据取品牌名，品牌区分苹果/安卓结算组）**********/
			getChannelSettle(data, channel) {
				if (!data || !channel) return null;
				return calcSettlePrice(this.settleConfigMap, channel.channel_id, data.brand_name, channel.sale_price);
			},

			/*********统一涨/降价后的预计结算价（按各渠道自身公式测算）**********/
			getAmountSettle(data, channel) {
				return calcSettlePrice(this.settleConfigMap, channel.channel_id, data.brand_name, this.getAmountPrice(data, channel));
			},

			/*********获取统一调整模式下展示的渠道列表（按筛选渠道过滤）**********/
			getAmountChannels(data) {
				var list = data.channel_list || [];
				if (!this.amountChannelId) return list;
				return list.filter(item => item.channel_id == this.amountChannelId);
			},

			/*********获取筛选渠道名称**********/
			getAmountChannelName() {
				if (!this.amountChannelId) return '';
				for (var i = 0; i < this.productList.length; i++) {
					var channel = (this.productList[i].channel_list || []).find(item => item.channel_id == this.amountChannelId);
					if (channel) return channel.channel_name;
				}
				return '';
			},

			/*********获取统一调整后价格**********/
			getAmountPrice(data, channel) {
				if (data._amountApplied && parseFloat(this.adjustAmount) > 0) {
					var current = parseFloat(channel.sale_price);
					if (isNaN(current)) return '';
					var amount = parseFloat(this.adjustAmount);
					return this.adjustType == 2 ? current - amount : current + amount;
				}
				return channel.sale_price;
			},

			/*********应用统一调整**********/
			applyAmount() {
				if (!(parseFloat(this.adjustAmount) > 0)) {
					this.$message({message: '请输入调整金额', type: 'warn'});
					return;
				}
				var rows = this.$refs.amountList.rows || [];
				if (!rows.length) {
					this.$message({message: '请先查询商品列表', type: 'warn'});
					return;
				}
				rows.forEach(row => {
					this.$set(row.data, '_amountApplied', true);
				});
			},

			/*********重置统一调整**********/
			resetAmount() {
				this.adjustAmount = '';
				(this.$refs.amountList.rows || []).forEach(row => {
					this.$set(row.data, '_amountApplied', false);
				});
			},

			/*********获取产品信息文字**********/
			getProductText(data) {
				var parts = [];
				if (data.brand_name) parts.push(data.brand_name);
				if (data.model_name) parts.push(data.model_name);
				if (data.memory_name) parts.push(data.memory_name);
				if (data.color_name) parts.push(data.color_name);
				return parts.join(' ') || '-';
			},

			/*********等级tag样式映射**********/
			levelClass(level) {
				if (!level) return '';
				if (level.indexOf('充新') >= 0) return 'm-tag-good';
				if (level.indexOf('靓机') >= 0) return 'm-tag-blue';
				if (level.indexOf('小花') >= 0) return 'm-tag-purple';
				if (level.indexOf('大花') >= 0 || level.indexOf('外爆') >= 0) return 'm-tag-bad';
				return '';
			},

			/*********格式化金额（不带¥）**********/
			formatAmount(price) {
				if (price === null || price === undefined || price === '') return '-';
				var num = parseFloat(price);
				if (isNaN(num)) return '-';
				return num % 1 === 0 ? String(num) : num.toFixed(2);
			},

			/*********格式化价格**********/
			formatPrice(price) {
				if (price === null || price === undefined || price === '') return '-';
				return '¥' + parseFloat(price).toFixed(2);
			},

			/*********加载控价处置方式（与控价比例同源，一次请求取模式）**********/
			loadPriceControlMode() {
				this.request({
					url: '/sale/product/priceRatio/get',
					success: data => {
						this.controlMode = (data && data.control_mode) || 2;
					}
				});
			},

			/*********判断价格是否低于该商品最低控价（未维护控价比例时服务端不下发 min_price，不标红不提醒）**********/
			isBelowPrice(data, price) {
				if (!data) return false;
				var min = parseFloat(data.min_price);
				if (isNaN(min)) return false;
				var value = parseFloat(price);
				if (!(value > 0)) return false;
				return value < min;
			},

			/*********统计待提交行中破价条数（按已填写的新定价判定）**********/
			countBelowRows(rows) {
				var _this = this;
				return (rows || []).filter(item => _this.isBelowPrice(item, item.new_sale_price)).length;
			},

			/*********预估统一调价后破价条数（后端不依赖预览置位且覆盖全量数据，本页只能给估值，准确条数以服务端回传为准）**********/
			countBelowByAmount() {
				var amount = parseFloat(this.adjustAmount);
				if (!(amount > 0) || !this.productList.length) return 0;
				var _this = this;
				var count = 0;
				this.productList.forEach(data => {
					_this.getAmountChannels(data).forEach(channel => {
						if (_this.isBelowPrice(data, _this.getAdjustPrice(channel))) count++;
					});
				});
				return count;
			},

			/*********统一涨/降后的价格（与服务端口径一致，不受是否点过『确定』影响）**********/
			getAdjustPrice(channel) {
				var current = parseFloat(channel.sale_price);
				if (isNaN(current)) return '';
				var amount = parseFloat(this.adjustAmount);
				if (!(amount > 0)) return current;
				return this.adjustType == 2 ? current - amount : current + amount;
			},

			/*********破价放行时展示明细弹框，否则维持原提示**********/
			showWarnResult(data, msg) {
				if (data && data.price_warn_count > 0) {
					this.globalDialog('salePriceWarnResult', {
						data: data
					});
					return;
				}
				this.$message({message: msg || '改价成功', type: 'success'});
			},

			/*********提交改价**********/
			submitHandle(stop, next) {
				stop();
				if (this.mode == 1) {
					this.submitBySku(next);
				} else if (this.mode == 2) {
					this.submitByAmount(next);
				} else {
					this.submitSingle(next);
				}
			},

			/*********单商品渠道改价（复用同SKU改价接口，取表格行新定价）**********/
			submitSingle(next) {
				var rows = this.$refs.singleList.getData('all');
				var row = rows && rows.length ? rows[0] : null;
				var salePrice = parseFloat(row ? row.new_sale_price : '');
				if (!(salePrice > 0)) {
					this.$message({message: '请输入修改定价', type: 'warn'});
					return;
				}
				var below = this.isBelowPrice(row, salePrice);
				this.$confirm({
					message: below ? '售价' + salePrice + '元低于最低控价' + this.formatPrice(row.min_price) + '，确认继续改价？' : '确认将该商品【' + this.singleChannel.channel_name + '】渠道售价修改为' + salePrice + '元吗？',
					buttonName: '确定',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/sale/product/batchEditPriceBySku',
							data: {
								channel_id: this.singleChannel.channel_id,
								product_prices: [{
									product_id: this.singleProduct.id,
									sale_price: salePrice
								}]
							},
							loading: true,
							success: (data, msg) => {
								next();
								this.showWarnResult(data, msg);
								this.$emit('resolve');
							}
						});
					}
				});
			},

			/*********同SKU调整到相同价**********/
			submitBySku(next) {
				if (!this.channelId) {
					this.$message({message: '请先选择推送渠道', type: 'warn'});
					return;
				}
				var fillList = this.$refs.skuList.getData('all').filter(item => parseFloat(item.new_sale_price) > 0);
				var productPrices = fillList.map(item => {
					return {
						product_id: item.id,
						sale_price: parseFloat(item.new_sale_price)
					}
				});
				if (!productPrices.length) {
					this.$message({message: '请至少填写一个修改定价', type: 'warn'});
					return;
				}
				var belowCount = this.countBelowRows(fillList);
				this.$confirm({
					message: belowCount ? '所选' + productPrices.length + '个商品中有' + belowCount + '个售价低于最低控价，确认继续改价？' : '确认修改所选' + productPrices.length + '个商品的售价吗？',
					buttonName: '确定',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/sale/product/batchEditPriceBySku',
							data: {
								channel_id: this.channelId,
								product_prices: productPrices
							},
							loading: true,
							success: (data, msg) => {
								next();
								this.showWarnResult(data, msg);
								this.$emit('resolve');
							}
						});
					}
				});
			},

			/*********统一调整金额**********/
			submitByAmount(next) {
				var adjustAmount = parseFloat(this.adjustAmount);
				if (!(adjustAmount > 0)) {
					this.$message({message: '请输入调整金额', type: 'warn'});
					return;
				}
				if (!this.productList.length) {
					this.$message({message: '请先查询商品列表', type: 'warn'});
					return;
				}
				var channelName = this.getAmountChannelName();
				var belowCount = this.countBelowByAmount();
				var requestData = {
					adjust_type: this.adjustType,
					adjust_amount: adjustAmount
				};
				if (this.amountChannelId) {
					requestData.channel_id = this.amountChannelId;
				}
				this.$confirm({
					message: belowCount ? '统一' + (this.adjustType == 2 ? '降价' : '涨价') + '后预估有' + belowCount + '条售价低于最低控价，确认继续改价？' : '确认对' + (channelName ? '【' + channelName + '】渠道' : '所有渠道') + '已有售价的商品统一' + (this.adjustType == 2 ? '降价' : '涨价') + adjustAmount + '元吗？',
					buttonName: '确定',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/sale/product/batchEditPriceByAmount',
							data: requestData,
							loading: true,
							success: (data, msg) => {
								next();
								this.showWarnResult(data, msg);
								this.$emit('resolve');
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	::v-deep .c-dialog-body {
		padding: 0 12px;
	}

	// 搜索工具栏（边框外独立一行，左对齐）
	.m-toolbar {
		display: flex;
		align-items: left;
		gap: 10px;
		padding: 10px 20px;
	}

	// 批量填充栏（表格边框内，右对齐）
	.m-fill-bar {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		padding: 6px 10px;
		border-bottom: 1px solid #e8e8e8;
		background: #fafafa;

		.m-fill-right {
			display: flex;
			align-items: center;
			gap: 6px;

			label {
				font-size: 13px;
				color: #666;
			}
		}
	}

	// 调价方式工具栏（边框外独立一行，左对齐）
	.m-amount-form {
		display: flex;
		align-items: center;
		gap: 10px;
		padding: 10px 20px;

		label {
			font-size: 13px;
			color: #333;
		}
	}

	// 表格区域（带边框容器）
	.m-table-area {
		margin: 10px 20px;
		border: 1px solid #e8e8e8;
		border-radius: 4px;
		overflow: hidden;
	}

	// 表格单元格内容整体左对齐（组件默认居中且无左对齐属性，深度样式覆盖）
	.m-price-edit {
		::v-deep .c-table-head th > div {
			justify-content: flex-start;
		}

		::v-deep .c-table-body td {
			text-align: left;
		}

		::v-deep .c-table-body td > div {
			justify-content: flex-start;
		}
	}

	.m-amount-tips {
		padding: 6px 20px 10px;
		text-align: left;
		font-size: 12px;
		color: #999;
		line-height: 20px;
	}

	.m-new-price {
		p {
			line-height: 30px;
		}

		label {
			flex-shrink: 0;
			font-size: 13px;
			color: #333;
		}

		.m-below-tip {
			line-height: 18px;
			font-size: 12px;
			color: #ed3f14;
		}
	}

	.m-price-input {
		::v-deep input {
			background-color: #fffbe6;
			text-align: left;
		}
	}

	// 低于最低控价的定价：只标红不阻断，是否允许提交由控价方式决定
	.m-price-below {
		::v-deep input {
			border-color: #ed3f14 !important;
		}
	}

	.m-unit {
		margin-left: 4px;
		font-size: 12px;
		color: #999;
	}

	.m-settle {
		font-size: 12px;
		color: #999;
	}

	// 统一调整模式下结算价跟在渠道价后一行，与前面的价格拉开距离
	.m-settle-inline {
		margin-left: 8px;
	}

	.m-help-wrap {
		display: inline-flex;
		align-items: center;
		flex-shrink: 0;
	}

	.m-help {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 14px;
		height: 14px;
		margin-left: 4px;
		border: 1px solid #c0c4cc;
		border-radius: 50%;
		font-size: 10px;
		color: #909399;
		cursor: pointer;
	}

	.m-channel-price {
		p {
			line-height: 26px;
		}
	}

	.m-multi-line {
		p {
			line-height: 26px;
		}
		.red {
			color: #e53e3e;
		}

		.m-below-tag {
			margin-left: 4px;
			padding: 0 4px;
			border-radius: 2px;
			background: #ed3f14;
			color: #fff;
			font-size: 12px;
		}
	}

	.m-tag {
		display: inline-block;
		vertical-align: middle;
		padding: 0 6px;
		height: 18px;
		line-height: 18px;
		font-size: 12px;
		border-radius: 2px;
		color: #fff;
		background: #2b7be4;
		margin-right: 4px;

		&.m-tag-good {
			background: #19be6b;
		}
		&.m-tag-blue {
			background: #2b7be4;
		}
		&.m-tag-purple {
			background: #9254de;
		}
		&.m-tag-bad {
			background: #ed3f14;
		}
	}
</style>
